import { styled } from "@material-ui/core/styles";

const StyledForm = styled("form")(({ theme }) => ({
  padding: theme.spacing(1),
}));

export default StyledForm;
